import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IndexCard } from '../../../auth/store/models';
import { AlertService } from '../../../core/alerts/alert.service';


@Component({
    selector: 'app-statistik-daekning-options',
    templateUrl: './statistik-daekning-options.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StatistikDaekningOptionsComponent {
    @Input() laCards: IndexCard[];
    @Input() kaCards: IndexCard[];
    @Input() saCards: IndexCard[];
    @Input() koncerns: (string | undefined)[] = [];
    @Input() periode: {fra: string, til: string};
    @Input() laID: number;
    @Input() kaID: number;
    @Input() saID: number;
    @Output() showNullableObjects: EventEmitter<Boolean> = new EventEmitter<Boolean>();
    @Output() periodeChange = new EventEmitter<{fra: string, til: string}>();
    @Output() selectLedelseAnsvarlig = new EventEmitter<number>();
    @Output() selectKundeAnsvarlig = new EventEmitter<number>();
    @Output() selectSagsAnsvarlig = new EventEmitter<number>();
    @Output() selectKoncern = new EventEmitter<string>();
    @Output() exportExcel = new EventEmitter();
    selectedKoncern?: string;
    isChecked = false;

    constructor(
        private alert: AlertService
    ) { }

    onCheckboxChange() {
        this.showNullableObjects.emit(this.isChecked);
    }

    onFraChange(fra: string, isValidDate: boolean) {
        if (!isValidDate || !fra) { return; }
        if (!this.isValidPeriode(fra, this.periode.til)) { return; }
        this.periode.fra = fra;
        this.onPeriodeChange();
    }

    onTilChange(til: string, isValidDate: boolean) {
        if (!isValidDate || !til) { return; }
        if (!this.isValidPeriode(this.periode.fra, til)) { return; }
        this.periode.til = til;
        this.onPeriodeChange();
    }

    private onPeriodeChange() {
        if (!this.periode.fra || !this.periode.til) { return; }
        this.periodeChange.emit({fra: this.periode.fra, til: this.periode.til});
    }

    private isValidPeriode(fra: string, til: string) {
        if (new Date(fra) > new Date(til)) {
            this.alert.createAlert(
                'Til dato skal være større end fra dato!',
                'danger'
            );
            return false;
        }
        return true;
    }

    onSelectKundeAnsvarlig(id: number) {
        this.selectKundeAnsvarlig.emit(id);
        this.kaID = id;
    }

    onSelectLedelseAnsvarlig(id: number) {
        this.selectLedelseAnsvarlig.emit(id);
    }

    onSelectSagsAnsvarlig(id: number) {
        this.selectSagsAnsvarlig.emit(id);
        this.saID = id;
    }

    onSelectKoncern(koncernNavn?: string) {
        this.selectedKoncern = koncernNavn;
        this.selectKoncern.emit(koncernNavn);
    }

    findLaName(id: number): string {
        let name = '';
        if (this.laCards) {
            for (const c of this.laCards) {
                if (c.cardId === id) {
                    name = c.fornavn + ' ' + c.efternavn;
                    break;
                }
            }
        }
        return name;
    }

    findKaName(id: number): string {
        let name = '';
        if (this.kaCards) {
            for (const c of this.kaCards) {
                if (c.cardId === id) {
                    name = c.fornavn + ' ' + c.efternavn;
                    break;
                }
            }
        }
        return name;
    }

    findSaName(id: number): string {
        let name = '';
        if (this.saCards) {
            for (const c of this.saCards) {
                if (c.cardId === id) {
                    name = c.fornavn + ' ' + c.efternavn;
                    break;
                }
            }
        }
        return name;
    }

    onExportExcel() {
        this.exportExcel.emit();
    }
}
